import React from 'react';
import { reduxForm, Field } from 'redux-form/immutable';
import { useDispatch } from 'react-redux';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import Box from 'retired/Box';
import FormTextField from 'retired/FormTextField';
import FormFieldLabel from 'retired/FormFieldLabel';
import { required, isEmail } from 'utils/validators';
import { useInjectEpics } from 'utils/injectEpics';

import { DEMO_FORM_IDENTIFIER } from './constants';
import * as Actions from './actions';
import epics from './epics';

const requiredValidator = required();
const isEmailValidator = isEmail();

const key = 'userPage';

const DemoForm = ({ handleSubmit, submitting, invalid, pristine }) => {
  useInjectEpics({ key, epics });
  const dispatch = useDispatch();

  const cloneCompany = (data) => {
    dispatch(Actions.cloneCompanyAction({ ...data.toJS() }));
  };

  return (
    <Box style={{ maxWidth: 1200, marginTop: 30 }}>
      <form onSubmit={handleSubmit(cloneCompany)}>
        <fieldset>
          <Grid container spacing={3}>
            <Grid item xs={12} md={8}>
              <FormFieldLabel forName="cloneCompanyName">Create a Demo Company</FormFieldLabel>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <Field
                    id="cloneCompanyName"
                    name="cloneCompanyName"
                    component={FormTextField}
                    required
                    fullWidth
                    label="Demo Company Name"
                    validate={[requiredValidator]}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    id="cloneUserName"
                    name="cloneUserName"
                    component={FormTextField}
                    required
                    fullWidth
                    label="Demo User Name"
                    validate={requiredValidator}
                  />
                  <Field
                    id="cloneUserEmail"
                    name="cloneUserEmail"
                    component={FormTextField}
                    required
                    fullWidth
                    label="Demo User Email"
                    validate={[requiredValidator, isEmailValidator]}
                    style={{ marginTop: 20 }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <br />
          <br />
          <Typography align="right">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              disabled={invalid || submitting || pristine}
              onClick={handleSubmit(cloneCompany)}
            >
              Submit
            </Button>
          </Typography>
        </fieldset>
      </form>
    </Box>
  );
};

const withForm = reduxForm({
  form: DEMO_FORM_IDENTIFIER,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
});
export default withForm(DemoForm);
